export default __webpack_public_path__ + "static/media/mail.95293cdd.png";